export default "/images/penetration_testing_and_bug_bounty__icon.png";